import { useEffect, useState } from "react";
import { Save, Scale } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

const inputCls = "w-full rounded-lg border border-input bg-[#060B18] px-3 py-2 font-mono2 text-xs leading-relaxed text-white placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-orange-500";

export default function LegalTab() {
  const [legal, setLegal] = useState({ mentions_legales: "", cgv: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/legal").then((r) => setLegal(r.data)).catch((e) => toast.error(errMsg(e))).finally(() => setLoading(false));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/admin/legal", legal);
      toast.success("Pages légales mises à jour");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  if (loading) return <p className="text-slate-500">Chargement...</p>;

  return (
    <form onSubmit={save} className="card-tactical grid gap-5 p-6" data-testid="admin-legal-form">
      <p className="flex items-center gap-2 font-heading text-lg font-bold uppercase">
        <Scale className="h-5 w-5 text-orange-500" /> Mentions légales & CGV
      </p>
      <p className="text-xs text-slate-500">
        Textes pré-remplis avec des [crochets à compléter] : remplacez-les par vos informations (SIRET, adresse, médiateur...).
        Ces pages sont liées en bas de chaque page du site.
      </p>
      <label className="text-xs font-bold uppercase tracking-widest text-slate-400">
        Mentions légales
        <textarea value={legal.mentions_legales} rows={12} data-testid="admin-legal-mentions"
          onChange={(e) => setLegal({ ...legal, mentions_legales: e.target.value })} className={inputCls + " mt-1"} />
      </label>
      <label className="text-xs font-bold uppercase tracking-widest text-slate-400">
        Conditions Générales de Vente (CGV)
        <textarea value={legal.cgv} rows={14} data-testid="admin-legal-cgv"
          onChange={(e) => setLegal({ ...legal, cgv: e.target.value })} className={inputCls + " mt-1"} />
      </label>
      <button type="submit" data-testid="admin-legal-save"
        className="flex w-fit items-center gap-2 rounded-lg bg-orange-500 px-5 py-2.5 text-sm font-bold uppercase text-[#060B18] transition-all hover:scale-[1.02] hover:bg-orange-400">
        <Save className="h-4 w-4" /> Enregistrer
      </button>
    </form>
  );
}
